import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy  } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Router } from '@angular/router';
import { GeneralService } from '../../Services/generalservice.service';
import { HttpClient, HttpHandler, HttpResponse, HttpRequest } from '@angular/common/http';
@Component({
    selector: 'app-home-one',
    templateUrl: './home-one.component.html',
    styleUrls: ['./home-one.component.scss']
})
export class HomeOneComponent implements OnInit, AfterViewInit, OnDestroy {
    experienceOptions: string[] = [];
    skills: any;
    location: string = '';
    selectedExperience: string = '';
    CategoryData: any;
    arr: any[];
    RID: any;
    HomeUrl: any;
    CompanyFilter: any;
    Companies: any;
    ArticlesData: any;
    showAll = false;
    loginDet: any; 
    loginDetails: any; userDetails: any; AdsData: any;
    @ViewChild('scrollContainer') scrollContainer!: ElementRef;
    scrollInterval: any;
    /*colors: string[] = ['#FFCCCC', '#CCFFCC', '#CCCCFF', '#FFFFCC', '#FFCCFF', '#CCFFFF'];*/ // Add more colors as needed
    colors: string[] = ['#fff']; // Add more colors as needed
    Positions: any;
    skillOptions: any[] = [];

    filteredSkills: string[] = this.skillOptions;


    suggestedSkills: string[] = [];
    showSuggestions: boolean = false;
    debounceTimer: any;
    public suggestedLocations: any[] = [];
    public showLocationSuggestions: boolean = false;
    showSkillsSuggestions: boolean;
    constructor(private viewportScroller: ViewportScroller, public router: Router,
        public generalservice: GeneralService, public http: HttpClient) {
        this.loginDet = localStorage.getItem("LoginDetails");
        this.loginDetails = JSON.parse(this.loginDet)
        this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
        this.http.get('../assets/WebService.json').subscribe((data: any) => {
            this.HomeUrl = data.Webservice;
        });
    }

    public onClick(elementId: string): void { 
        this.viewportScroller.scrollToAnchor(elementId);
    }

    ngOnInit() {
        this.GetCategory();
        this.GetCompanies();
        this.getarticles();
        this.getadds();
        this.GetCompaniesAndPositions();
        // Populate experience options from 1 to 30 years
        for (let i = 1; i <= 30; i++) {
            this.experienceOptions.push(`${i} ${i === 1 ? 'Year' : 'Years'}`);
        }
    }

    ngAfterViewInit(): void {
        this.startAutoScroll();
    }

    startAutoScroll(): void {
        this.scrollInterval = setInterval(() => {
            const container = this.scrollContainer.nativeElement;
            if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
                container.scrollTop = 0; // Reset to the top
            } else {
                container.scrollTop += 1; // Scroll down by 1px
            }
        }, 50); // Adjust the interval for smoother or faster scrolling
    }

    ngOnDestroy(): void {
        if (this.scrollInterval) {
            clearInterval(this.scrollInterval);
        }
    }

    GetCategory() {
        debugger
        var url = "api/Njobs/Get_Company_Catageory_Count";
        this.generalservice.GetData(url).then(data => {
            debugger
            this.CategoryData = data;
        })
    }

    findJobs() {
        debugger
        //if (!this.userDetails) {
        //    //this.router.navigate(['/Login']);
        //    this.router.navigate(['/job']);
        //    return;
        //}
        //this.router.navigate(['/job'], {
        this.router.navigate(['/job'], {
            queryParams: {
                skills: this.skills,
                location: this.location,
                experience: this.selectedExperience
            }
        });
    }

    JobsFilter(CID:any) {
        debugger
        if (!this.userDetails) {
            this.generalservice.ShowAlert("Alert",'Your not login,Please Login',"alert")
            this.router.navigate(['/Login']);
            return;
        } else {
            this.router.navigate(['/job', { CID }]);
        }
    }
    navigateToCompanyDetails(RID: any) {
        if (!this.userDetails) { // Check if the user is not logged in
            this.generalservice.ShowAlert("Alert", 'You are not logged in. Please login.', "alert");
            this.router.navigate(['/Login']); // Navigate to the login page
            return;
        }
        this.router.navigate(['/companyinfo', { RID }]); // Navigate to the company info page
    }

    navigateToCompanyProfile(RID: any) {
        if (!this.userDetails) { // Check if the user is not logged in
            this.generalservice.ShowAlert("Alert", 'You are not logged in. Please login.', "alert");
            this.router.navigate(['/Login']); // Navigate to the login page
            return;
        }
        this.router.navigate(['/CompanyProfile', { RID }]); // Navigate to the company profile page
    }


    PostJobsFilter(RID: any) {
        debugger
        if (!this.userDetails) {
            this.generalservice.ShowAlert("Alert", 'Your not login,Please Login', "alert")
            this.router.navigate(['/recuiter-login']);
            return;
        } else {
            this.router.navigate(['/company-account', { RID }]);
        }
    }

    GetCompanies() {
        debugger
        this.arr = [];
        this.arr.push({
           // RID: this.loginDetails[0].RID
        });

        var UploadFile = new FormData();
        UploadFile.append("Param", JSON.stringify(this.arr));
        UploadFile.append("Flag", '8');

        var url = "api/Njobs/RecruiterRegister_Crud";
        this.generalservice.PostData(url, UploadFile).then((data: any) => {
            debugger
            this.Companies = data;
        },
            err => {
                this.generalservice.ShowAlert('ERROR', 'Something went wrong, please try again later', 'error');
            });
    }

    GetCompaniesAndPositions() {
        debugger
        var url = "api/Njobs/Get_CompanysAndPositions_Count";
        this.generalservice.GetData(url).then((data: any) => {
            debugger
            this.Positions = data;
        },
            err => {
                this.generalservice.ShowAlert('ERROR', 'Something went wrong, please try again later', 'error');
            });
    }

    //navigateToCompanyDetails(RID: any) {
    //    debugger
    //    this.router.navigate(['/companyinfo', { RID: RID }]);
    //}

    //navigateToCompanies() {
    //    this.router.navigate(['/CompanyProfile']); // Adjust '/companies' to the actual route of your companies page
    //}
    navigateToArticles() {
        this.router.navigate(['/Articles']);
    }
    navigateToArticleDetails(AID: any) {
        debugger
        this.router.navigate(['/Articlesdetails', { AID: AID }]);
    }
    // Navigate to the detailed company profile page
    //navigateToCompanyProfile() {
    //    this.router.navigate(['/CompanyProfile']);
    //}
    uploadresume() {
        if (!this.userDetails) {
            this.router.navigate(['/Login']);
        } else {
            this.router.navigate(['/useraccount']);
        }
    }

    getadds() {
        debugger
        this.arr = [];
        this.arr.push({

        })
        var uploadfile = new FormData();
        uploadfile.append("Param", JSON.stringify(this.arr));
        uploadfile.append("Flag", '5');
        var url = "api/Njobs/NJ_Adds_Crud";
        this.generalservice.PostData(url, uploadfile).then(data => {
            this.AdsData = data;
        })

    }

    getarticles() {
        debugger
        this.arr = [];
        this.arr.push({

        })
        var uploadfile = new FormData();
        uploadfile.append("Param", JSON.stringify(this.arr));
        uploadfile.append("Flag", '7');
        var url = "api/Njobs/NJ_Articles_Crud";
        this.generalservice.PostData(url, uploadfile).then(data => {
            this.ArticlesData = data;
        })

    }

    getCardColor(index: number): string {
        return this.colors[index % this.colors.length];
    }

    onImageError(event: any) {
        event.target.src = '../../../assets/img/logo.jpeg';
    }

    //After applying job by JobSeeker, that application is inserting method
    applujob(job: any) {
        if (!this.userDetails) {
            this.generalservice.ShowAlert("Alert", 'You are not logged in. Please log in to apply for jobs.', 'Alert');
            this.router.navigate(['/Login']);
            return;
        }

        if (this.userDetails.ApprovalStatus === 1) {
            this.generalservice.ShowAlert("ERROR", 'You do not have permission to apply for jobs. Admin approval is required.', 'error');
            return;
        }

        // Apply for job logic
        this.arr = [{
            SeekerID: this.userDetails.RegId,
            P_ID: job.PID,
            R_ID: job.RID,
            ActionStatus: 1,
            AppliedStatus: 1
        }];
        var uploadfile = new FormData();
        uploadfile.append("xml", JSON.stringify(this.arr));

        var url = "api/Njobs/Insert_Applied_Job";
        this.generalservice.PostData(url, uploadfile).then(data => {
            if (data === "SUCCESS") {
                this.generalservice.ShowAlert("SUCCESS", 'You have successfully applied for this job.', 'success');
            } else {
                this.generalservice.ShowAlert("ERROR", 'Something went wrong. Please try again later.', 'error');
            }
        });
    }


    onSearchInputChange(fieldName: string, value: string): void {
        if (fieldName !== 'skills') {
            return;
        }

        // Clear previous timer to prevent excessive API calls
        clearTimeout(this.debounceTimer);
        this.skills = value; // Update the model (ngModel)

        if (!value || value.trim().length === 0) {
            this.suggestedSkills = [];
            this.showSuggestions = false;
            return;
        }

        // Set a new timer.
        this.debounceTimer = setTimeout(() => {
            this.fetchSkills(value.trim());
        }, 300);
    }

    // 2. API call to fetch suggested skills
    async fetchSkills(searchTerm: string): Promise<void> {
        const url = 'api/Njobs/GetSkillsForDropdown';

        try {
            const fullUrl = `${url}?searchTerm=${encodeURIComponent(searchTerm)}`;

            // Assuming this.General.GetData is available and handles GET requests
            const response: any = await this.generalservice.GetData(fullUrl);

            if (response && response.success === true && Array.isArray(response.skills)) {
                this.suggestedSkills = response.skills;
                this.showSuggestions = this.suggestedSkills.length > 0;
            } else {
                this.suggestedSkills = [];
                this.showSuggestions = false;
            }

        } catch (error) {
            console.error("Error fetching skill suggestions:", error);
            this.suggestedSkills = [];
            this.showSuggestions = false;
        }
    }

    // 3. Selection handler
    selectSkill(skillName: string): void {
        this.skills = skillName;
        this.suggestedSkills = [];
        this.showSuggestions = false;
    }


    // 1. UPDATED: onSearchInputChange Method
    // This method handles both 'skills' and 'location' inputs.
    onSearchInputChange1(fieldName: 'skills' | 'location', value: string): void {

        clearTimeout(this.debounceTimer);

        // Update ngModel and manage visibility for both dropdowns
        if (fieldName === 'skills') {
            this.skills = value;
            this.showLocationSuggestions = false; // Hide location dropdown when typing skills
        } else if (fieldName === 'location') {
            this.location = value;
            this.showSkillsSuggestions = false; // Hide skills dropdown when typing location
        }

        if (!value || value.trim().length < 1) {
            this.suggestedLocations = [];
            this.showLocationSuggestions = false;
            // Keep suggestedSkills clear if needed, but primary focus is clearing location
            return;
        }

        // Debounce the fetch call
        this.debounceTimer = setTimeout(() => {
            if (fieldName === 'location') {
                this.fetchLocations(value.trim());
            }
            // Logic for skills search should be handled in an 'else if' block for fieldName === 'skills'
        }, 300);
    }

    // 2. NEW: fetchLocations Method
    async fetchLocations(searchTerm: string): Promise<void> {
        const url = 'api/Njobs/GetLocationsForDropdown';

        try {
            const fullUrl = `${url}?searchTerm=${encodeURIComponent(searchTerm)}`;

            // Use the General service to make the GET request
            const response: any = await this.generalservice.GetData(fullUrl);

            // IMPORTANT: The Controller returns the list under the key 'skills', so we access response.skills
            if (response && response.success === true && Array.isArray(response.skills)) {
                this.suggestedLocations = response.skills;
                this.showLocationSuggestions = this.suggestedLocations.length > 0;
            } else {
                this.suggestedLocations = [];
                this.showLocationSuggestions = false;
            }

        } catch (error) {
            console.error("Error fetching location suggestions:", error);
            this.suggestedLocations = [];
            this.showLocationSuggestions = false;
        }
    }

    // 3. NEW: selectLocation Method
    selectLocation(locationName: string): void {
        this.location = locationName; // Set the input field value
        this.suggestedLocations = []; // Clear suggestions
        this.showLocationSuggestions = false; // Hide the dropdown
    }


}
